import { ReactNode } from 'react';
import { RuleSet } from 'styled-components';
import { CloseButtonAlignType } from '../Modal/types';

export enum BackButtonIconEnum {
  Back = 'back',
  Close = 'close',
  InternalNavigationBackButton = 'InternalNavigationBackButton'
}

export enum HeaderPosition {
  Fixed = 'fixed',
  Sticky = 'sticky'
}

export interface PageHeaderProps {
  id?: string;
  title?: string | ReactNode;
  titleCypress?: string;
  backButtonCypress?: string;
  titleIcon?: ReactNode;
  rightBlock?: ReactNode;
  icon?: BackButtonIconEnum;
  height?: number;
  bottomBlock?: ReactNode;
  onClick: () => void;
  showHeaderBorder?: boolean;
  closeButtonAlign?: CloseButtonAlignType;
  headerPosition?: HeaderPosition;
  headerTag?: string;
  styles?: RuleSet<object>;
  leftBlock?: ReactNode;
}
